<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-row>
                <el-col :span="6">
                    <el-form :inline="true" :model="form" class="demo-form-inline">
                        <el-form-item label="Crear grupo">
                            <el-input v-model="form.groupName" placeholder="Nombre"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="saveGroup">Crear</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
                <!-- <el-col span="6">
                    <el-button type="text" @click="centerDialogVisible = true"> Creación automatica </el-button>

                    <el-dialog
                    title="Creación automatica"
                    :visible.sync="centerDialogVisible"
                    width="30%"
                    center>
                    <span>Seleccione el numero de equipos por grupo</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="centerDialogVisible = false">Cancel</el-button>
                        <el-button type="primary" @click="centerDialogVisible = false">Confirm</el-button>
                    </span>
                    </el-dialog>
                </el-col>-->
            </el-row>

            <el-row>
                <el-col :span="20">
                    <el-row>
                        <el-col
                            :span="4"
                            v-for="(item, index) in groupList"
                            :key="item.id"
                            :label="item"
                            :name="item"
                        >
                            <div class="grid-content bg-purple">
                                <div class="grid-content bg-purple">
                                    <div class="board-column">
                                        <div
                                            class="board-column-header"
                                            :style="item.isClose ? bgColorGrupoCerrado : ''"
                                        >
                                            {{item.name}}
                                            <!-- generar partidos -->
                                            <el-button
                                                :type="item.isClose ? 'warning' : 'success'"
                                                @click="generateMatchesGroup(item)"
                                                :icon="item.isClose ? 'el-icon-setting' : 'el-icon-check'"
                                                style="float: right;"
                                                circle
                                            ></el-button>

                                            <!-- Eliminar grupo -->
                                            <el-button
                                                v-if="!item.isClose && item.teamList.length ==0"
                                                type="danger"
                                                @click="destroyGroup(item)"
                                                icon="el-icon-delete"
                                                style="float: right;"
                                                circle
                                            ></el-button>
                                        </div>
                                        <draggable
                                            :list="item.teamList"
                                            :group="item.isClose ? item.id : 'groups'"
                                            :id="item.id"
                                            class="board-column-content"
                                            :move="checkMove"
                                            @moved="onMoved"
                                            @end="onEnd"
                                        >
                                            <div
                                                v-for="element in item.teamList"
                                                :key="element.id"
                                                class="board-item"
                                            >{{ element.name }}</div>
                                        </draggable>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>

                <el-col :span="4">
                    <!-- Creacion de grupos -->
                    <div class="grid-content bg-purple">
                        <div class="grid-content bg-purple">
                            <div class="board-column">
                                <div
                                    class="board-column-header"
                                    style="background: gray;"
                                >Equipos sin grupo</div>
                                <draggable
                                    :list="teamList"
                                    group="groups"
                                    class="board-column-content"
                                    :move="checkMove"
                                    @end="onEnd"
                                    @moved="onMoved"
                                >
                                    <div
                                        v-for="element in teamList"
                                        :key="element.id"
                                        :id="element.id"
                                        class="board-item"
                                    >{{ element.name }}</div>
                                </draggable>
                            </div>
                        </div>
                    </div>
                    <!-- -->
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";

// import _ from "underscore";
// import Cookies from 'js-cookie' // birthdate

/* eslint-disable */
import moment from "moment"; // birthdate

export default {
    name: "app-setting-groups-list",

    components: {
        draggable
    },

    props: {
        categoryId: String
    },

    data() {
        return {
            options: ["A", "B", "C", "D"],
            list1: [],
            list2: [
                { name: "Juan", id: 5 },
                { name: "Edgard", id: 6 },
                { name: "Johnson", id: 7 }
            ],

            bgColorGrupoCerrado: "background: red;", // Style
            centerDialogVisible: false,

            form: { groupName: "" }, // USE!!
            currentItem: {} // USE!!
        };
    },

    computed: {
        ...mapGetters({
            loading: "entities/tournament/settingGroups/loading",
            teamList: "entities/tournament/settingGroups/teamList", // USE!!
            groupList: "entities/tournament/settingGroups/groupList", // USE!!
            modelSetting: "entities/tournament/model",
            isMobile: "shared/isMobile"
        })
    },

    created() {
        this.$store.dispatch(
            "entities/tournament/settingGroups/listTeamsByCategoryId",
            this.categoryId
        );
        this.$store.dispatch(
            "entities/tournament/settingGroups/listGroup",
            this.categoryId
        );
    },

    beforeRouteLeave(to, from, next) {
        console.log("<--- beforeRouteLeave ");
        this.$store.dispatch("entities/tournament/settingGroups/clear");
        next();
    },

    beforeRouteUpdate(to, from, next) {
        console.log("<--- beforeRouteUpdate");

        console.log(to);
        console.log(from);
        this.$store.dispatch(
            "entities/tournament/settingGroups/listTeamsByCategoryId",
            to.params.categoryId
        );
        this.$store.dispatch(
            "entities/tournament/settingGroups/listGroup",
            to.params.categoryId
        );
        next();
    },

    methods: {
        saveGroup() {
            const modelToSave = {
                categoryId: this.categoryId,
                name: this.form.groupName,
                teamList: []
            };

            if (modelToSave.name !== "") {
                this.$store
                    .dispatch(
                        "entities/tournament/settingGroups/saveGroup",
                        modelToSave
                    )
                    .then(() => {
                        this.$store.dispatch(
                            "entities/tournament/settingGroups/listGroup",
                            this.categoryId
                        );
                    });

                this.form.groupName = "";
            }
        },

        destroyGroup(groupModel) {
            this.$store
                .dispatch(
                    "entities/tournament/settingGroups/destroyGroup",
                    groupModel
                )
                .then(() => {
                    this.$store.dispatch(
                        "entities/tournament/settingGroups/listGroup",
                        this.categoryId
                    );
                });

            this.form.groupName = "";
        },

        generateMatchesGroup(groupModel) {
            // cerrar grupo
            if (!groupModel.isClose) {
                this.$store
                    .dispatch(
                        "entities/tournament/settingGroups/closeGroup",
                        groupModel
                    )
                    .then(() => {
                        this.$store.dispatch(
                            "entities/tournament/settingGroups/listGroup",
                            this.categoryId
                        );
                    });
            } else {
                this.$store
                    .dispatch(
                        "entities/tournament/settingGroups/openGroup",
                        groupModel
                    )
                    .then(() => {
                        this.$store.dispatch(
                            "entities/tournament/settingGroups/listGroup",
                            this.categoryId
                        );
                    });
            }
        },

        // Groups functions

        /*
            Comprueba si se puede mover un elemento
        */

        checkMove: function(card, origin) {
            this.currentItem = card.draggedContext.element;

            return this.modelSetting.permises.settingGroups;
        },

        onEnd: function(card) {
            console.log("<--- END", card);
            const toGroupId = card.to.id;
            const fromGroupId = card.from.id;
            const modelToSave = {
                to: { groupId: card.to.id },
                from: { groupId: card.from.id },
                team: this.currentItem,
                categoryId: this.categoryId
            };
            
            this.$store.dispatch(
                "entities/tournament/settingGroups/addTeamGroup",
                modelToSave
            );
        },

        onMoved: function(card) {
            console.log("<--- ON MOVED");
        }
    }

    // beforeUpdate(to, from, next) {
    //     next()
    // },

    // created() {
    //     this.dialogTableVisible = true;
    // },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/color.scss";

.board-column {
    margin: 1%;
    min-width: 200px;
    min-height: 100px;
    height: auto;
    overflow: hidden;
    background: #f0f0f0;
    border-radius: 3px;
    .board-column-header {
        height: 3o0px;
        line-height: 50px;
        overflow: hidden;
        padding: 0 20px;
        text-align: center;
        background: $--color-primary;
        color: #fff;
        border-radius: 3px 3px 0 0;
    }
    .board-column-content {
        height: auto;
        overflow: hidden;
        border: 10px solid transparent;
        min-height: 300px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        align-items: center;
        .board-item {
            cursor: pointer;
            width: 100%;
            height: 44px;
            margin: 5px 0;
            background-color: #fff;
            text-align: left;
            line-height: 54px;
            padding: 2px 6px;
            box-sizing: border-box;
            box-shadow: 0px 1px 3px 0 rgba(0, 0, 0, 0.2);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/entities/tournament/setting-groups/setting-groups.vue?1221e014